export default __webpack_public_path__ + "static/hetzner_community_2-b63351a09316a0b18fdec087997c492f.jpg";